import CRUDService from './CRUDService';

interface AdminAccessOrganization {
  _id?: string;
  name: string;
  display_name?: string;
  address: string;
  city: string;
  state: string;
  zip: string;
  phone: string;
  url?: string;
  slug?: string;
  landing_page_values?: {
    landing_text_1?: string;
    landing_text_2?: string;
    button_text?: string;
  };
}

export type {AdminAccessOrganization};
export default new CRUDService<AdminAccessOrganization>('/admin/access_organizations');
